import clsx from 'clsx';
import React from 'react';
import { SvgIcon } from '../../../../base-components/SvgIcon.js';
import styles from './IconDown.module.scss';

export const IconDown = ({ flip = false }) => {
  return (
    <SvgIcon width={13} height={7}>
      <path
        d="m.923 1 5.539 5L12 1"
        fill="none"
        className={clsx(flip && styles.flip)}
      />
    </SvgIcon>
  );
};
